/** @jsx jsx */

import { Button, Flex, Text, jsx } from "theme-ui"
import { Increment, Decrement } from "./Icons"

import Bounce from "../../hooks/useBounce"

function Buttons({
  productId,
  bundle,
  color,
  increment,
  decrement,
  disabled,
  numItems,
  bundleSize,
}) {
  const styles = {
    button: {
      display: "flex",
      height: "1em",
      width: "1em",
      opacity: disabled || numItems >= bundleSize ? "0.5" : "1",
      margin: "0px auto",
      textAlign: "center",
      padding: "0px",
      justifyContent: "center",
      alignItems: "center",
      background: "transparent",
    },
    p: {
      opacity: disabled ? "0.5" : "1",
      padding: "0 0.4em",
      width: "1.45em",
      textAlign: "center",
    },
  }

  const bundleProduct = bundle.find(b => b.productId === productId)

  const quantity = bundleProduct ? bundleProduct.quantity : 0

  return (
    <Flex sx={{ alignItems: "center" }}>
      <Bounce>
        <Button
          disabled={disabled || quantity === 0}
          sx={{
            ...styles.button,
            opacity: quantity === 0 ? "0.5" : "1",
          }}
          onClick={() => decrement()}
        >
          <Decrement color={color} />
        </Button>
      </Bounce>
      <Text sx={styles.p} as="p">
        {quantity}
      </Text>
      <Bounce>
        <Button
          disabled={disabled || numItems >= bundleSize}
          sx={styles.button}
          onClick={() => increment()}
        >
          <Increment color={color} />
        </Button>
      </Bounce>
    </Flex>
  )
}

export default Buttons
